export default {
    lang: {
        name: 'Play Date'
    }
}